import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { map, tap } from "rxjs/operators";
import { environment } from "src/environments/environment";
import { MadAuthService } from "../../mad-auth/mad-auth.service";
import { HttpUtilsService } from "../../_base/crud";
import { ReportingProcessData } from "../_models/reporting_process.model";
import { SubdomainService } from "../../_base/subdomain.service";


@Injectable()
export class ReportingProcessService {
    API_URL = environment.baseApiUrl + `api/${this.subDomainService.subDomain}/reporting`;
    constructor(private http: HttpClient, private authService: MadAuthService, private subDomainService: SubdomainService) {}

    get(id: number): Observable<{reporting: ReportingProcessData, toe_restrictions_on_use: number}> {
        const headers = this.authService.getAuthHeaders();
        return this.http.get<{reporting: ReportingProcessData, toe_restrictions_on_use: number}>(`${this.API_URL}/${id}`, {
            headers
        }).pipe(map(res => res));
    }

    getMultimedia(id: number): Observable<{reporting: ReportingProcessData, toe_restrictions_on_use: number}> {
        return this.http.get<
            {reporting: ReportingProcessData, toe_restrictions_on_use: number}>(
                `${environment.baseApiUrl}api/${this.subDomainService.subDomain}/multimedia/reporting/${id}`
            ).pipe(map(res => res));
    }
   
    create(tpId: number, data: ReportingProcessData): Observable<number> {
        const headers = this.authService.getAuthHeaders();
        return this.http.post<number>(this.API_URL, {
            tpId: tpId,
            ...data
        }, {
            headers
        });
    }

    update(id: number, data: ReportingProcessData): Observable<number> {
        const headers = this.authService.getAuthHeaders();
        return this.http.put<number>(`${this.API_URL}/${id}`, data, {
            headers
        });
    }

}